/* @flow */
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const types = {
    SALE: 'WEEKLY_SALE',
    NET: 'NET',
    RETAIL: 'RETAIL',
    SOLD: 'SOLD',
    HOLD: 'HOLD',
    UNAVAILABLE: 'UNAVAILABLE',
    PUR: 'PUR',
};

const textPriceTypes = [types.SOLD, types.UNAVAILABLE, types.PUR, types.HOLD];

export const isValidTextPriceType = (type: string) => textPriceTypes.includes(type);

export const textPriceValue = (textPriceType: string) => (
    <FormattedMessage
        values={{ textPriceType }}
        id="dc.searchProductTile.textPriceValue"
        defaultMessage={`{textPriceType, select,
            SOLD {Sold}
            UNAVAILABLE {Unavailable}
            PUR {Price Upon Request}
            HOLD {On Hold}
            other {Sold}
        }`}
    />
);

export const textPercentageOff = (percentageOff: number) => (
    <FormattedMessage
        id="dc.searchProductTile.percentageOff"
        defaultMessage={`{percentageOff}% Off`}
        values={{ percentageOff }}
    />
);
